import { handleActions } from 'redux-actions';
import * as actions from './actions';
import { sessionLoadSuccess } from "../auth-user/actions";

const defaultState = {
  email: '',
  password: '',
  confirmpPassword: '',
  formErrors: {},
  isLoading: false,
  error: null
};

const registerByEmailReducer = handleActions(
  {
    [actions.setEmail]: (state, action) => ({ ...state, email: action.payload }),
    [actions.setPassword]: (state, action) => ({ ...state, password: action.payload }),
    [actions.setConfirmPassword]: (state, action) => ({ ...state, confirmPassword: action.payload }),
    [actions.setFormErrors]: (state, action) => ({ ...state, formErrors: action.payload }),
    [actions.emailRegisterRequest]: (state, action) => ({ ...state, isLoading: true }),
    [actions.emailRegisterSuccess]: (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    },
    [actions.emailRegisterFailed]: (state, action) => ({ ...state, isLoading: false, error: action.payload }),

    [sessionLoadSuccess]: (state, action) => {
      return {
        ...state,
        email: '',
        password: '',
        formErrors: {},
      }
    }
  },
  defaultState
);

export default registerByEmailReducer;